import React from 'react';
import SignageLayoutSlot from './SignageLayoutSlot';
import { getPlaylistDataByID, getPlaylistIDBySlot } from '../../helpers/ContentJsonHelper'
import './SignageScreenLayout.css';
import SignageVideoMedia from './SignageVideoMedia';

class SignageScreenLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = { time: 0, backgroundColor: '#000000' };

        const { screenwidth = window.outerWidth, screenheight = window.outerHeight } = this.props;

        this.width = screenwidth;
        this.height = screenheight;
        // this.width = document.body.clientWidth;
        // this.height = document.body.clientHeight;
    }

    componentDidMount() {
        const { layoutdata } = this.props;

        // console.log("layoutdata.width " + layoutdata.width)
        // console.log("layoutdata.background_color " + layoutdata.background_color)
        if ("background_color" in layoutdata) {

            this.setState({ backgroundColor: layoutdata.background_color });
        }
    }

    renderSlots = (scaleX = 1, scaleY = 1) => {
        const { contentjson, timelinedata, layoutdata } = this.props;

        var slots = [];

        for (var i = 0; i < layoutdata.slots.length; i++) {

            const playlistID = getPlaylistIDBySlot(timelinedata, layoutdata.slots[i].slot_id)
            const playlistData = getPlaylistDataByID(contentjson, playlistID)

            var mediaData = null

            if (playlistData != null) {
                mediaData = this.getCurrentSlotMedia(playlistData, this.state.time);
            }

            slots.push(<SignageLayoutSlot scaleX={scaleX} scaleY={scaleY} key={"slot" + layoutdata.slots[i].slot_id} slotdata={layoutdata.slots[i]}>
                {this.renderMedia(mediaData, layoutdata.slots[i])}
            </SignageLayoutSlot>);


            // if(mediaData.type === "video")
            // {
            //     console.log("ALOHA")
            //     console.log(document.getElementById(mediaData.media_id));
            //     document.getElementById(mediaData.media_id).currentTime = 3000;
            // }
        }

        return slots;
    }

    onWidgetIFrameLoaded = (data) => {

        console.log("onWidgetIFrameLoaded " + JSON.stringify(data))
        if (data) {
            this.applyInstanceSetting(data)
            this.setState({ isLoaded: true })
        }
        else {
            // this.setState{ widgetInstanceData: undefined }
        }
    }


    applyInstanceSetting = (medaiData) => {
        if (!medaiData) {
            this.widgetSettings = {}
            this.applySettings(this.widgetSettings)
            return;
        }

        this.widgetSettings = JSON.parse(medaiData.setting)

        console.log("medaiDatamedaiDatamedaiDatamedaiDatamedaiDatamedaiData " + JSON.stringify(medaiData))
        this.applySettings(this.widgetSettings, medaiData.media_id)
    }


    applySettings = (settings, target) => {
        const iframeWin = document.getElementById(`widget-iframe-${target}`)

        iframeWin.contentWindow.postMessage(JSON.stringify({ action: "on_setting_update", param: settings, target: target }), "*")
    }

    renderMedia = (mediaData, slotdata = null) => {
        if (mediaData === null) {
            return null;
        }

        const { debug, controls, brand = "", mall = "", unit = "", screenwidth = window.outerWidth, screenheight = window.outerHeight } = this.props;
        console.log("mediaData.type " + mediaData.type)

        switch (mediaData.type) {
            case "image":
                return <img alt={mediaData.media_id} id={mediaData.media_id} src={mediaData.path} style={{ width: '100%', height: '100%', objectFit: mediaData.scale }}></img>
            case "video":
                var width = 1
                var height = 1
                var newWidth = 1;
                var newHeight = 1;
                var scaleX = 1;
                var scaleY = 1;
                if (slotdata) {


                    const { layoutdata } = this.props;
                    if ("width" in layoutdata) {
                        this.width = layoutdata.width;
                    }
                    if ("height" in layoutdata) {
                        this.height = layoutdata.height;
                    }

                    scaleX = parseFloat(this.width) == 0 ? 1 : screenwidth / parseFloat(this.width);
                    scaleY = parseFloat(this.height) == 0 ? 1 : screenheight / parseFloat(this.height);

                    width = slotdata.width;
                    height = slotdata.height;

                    newWidth = parseFloat(width) * parseFloat(scaleX);
                    newHeight = parseFloat(height) * parseFloat(scaleY);
                }
                return (

                    <SignageVideoMedia debugText={`width:${newWidth}, height:${newHeight}, scaleX:${scaleX}, scaleY:${scaleY}`} debug={debug} brand={brand} mall={mall} unit={unit} controls={controls} mediaData={mediaData}></SignageVideoMedia>
                );
            case "web":
                return <iframe ref={this.iframeRef} style={{ overFlow: "hidden", width: '100%', height: '100%', WebkitTransform: 'scale(1.01)' }} src={mediaData.path} sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin"></iframe>
                break;
            case "widget":
                console.log("widget " + mediaData.path)
                return <iframe allowTransparency="true" onLoad={() => this.onWidgetIFrameLoaded(mediaData)} id={`widget-iframe-${mediaData.media_id}`} frameBorder="none" style={{ height: "100%", width: "100%" }} src={`${mediaData.path}?id=${mediaData.media_id}`}></iframe>
                break;

            default:
                return null;
        }
    }

    getCurrentSlotMedia = (playlistData, time) => {

        // console.log(time)
        var inRoundTime = time - Math.floor(time / playlistData.total_time) * playlistData.total_time;


        // console.log("inRoundTime " + playlistData.total_time)
        var toplayContents = playlistData.contents.filter((content) => {
            return (content.playlist_start_time <= inRoundTime) && (content.playlist_start_time + content.duration >= inRoundTime) && (content.duration > 0);
        })

        // console.log("toplayContents " + JSON.stringify(toplayContents))
        // console.log("toplayContents.length  " + toplayContents.length )
        if (toplayContents.length > 0) {
            return toplayContents[0];
        }

        return null;
    }

    // getTotalPlaylistTime = (playlistData) => {
    //     for(var i=0; i<playlistData.contents.length; i++)
    //     {
    //         playlistData.contents[i].
    //     }
    // }

    reset = () => {
        this.setState({ time: 0 });
    }

    onTick = () => {
        this.setState({ time: this.state.time + 1 });
    }

    render() {
        const { screenwidth = window.outerWidth, screenheight = window.outerHeight } = this.props;

        if (this.props.data === null) {
            return null;
        }
        else {

            const { layoutdata } = this.props;
            if ("width" in layoutdata) {
                this.width = layoutdata.width;
            }
            if ("height" in layoutdata) {
                this.height = layoutdata.height;
            }

            const scaleX = parseFloat(this.width) == 0 ? 1 : screenwidth / parseFloat(this.width);
            const scaleY = parseFloat(this.height) == 0 ? 1 : screenheight / parseFloat(this.height);

            // console.log("document.body.clientWidth " + window.outerWidth)
            // console.log("this.width " + this.width)
            // console.log("scaleX " + scaleX)
            // console.log("bgcolor " + this.state.backgroundColor);
            return (<div style={{ backgroundColor: this.state.backgroundColor, width: screenwidth, height: screenheight, position: "relative" }}>
                {this.renderSlots(scaleX, scaleY)}
            </div>);
        }
    }
}

export default SignageScreenLayout;